import { AxiosError } from 'axios'
import forEach from 'lodash/forEach'
import set from 'lodash/set'

import { ENDPOINT } from '../../../environment'

import { ImageSource } from '../model'
import { isPresent } from './lang'

type ValidationErrors = {
  [key: string]: string
}

export function getNumerOfPages(allItemCount: number, pageSize: number) {
  return Math.ceil(allItemCount / pageSize)
}

export function getValidationErrors(payload: AxiosError): ValidationErrors {
  if (isPresent(payload.response) && isPresent(payload.response.data.validationErrors)) {
    // if returned "path", convert it to object because of "not-proper" react final form implementation
    return recompose(payload.response.data.validationErrors) as ValidationErrors
  }

  return {}
}

export function recompose(source: object): object {
  const result = {}

  forEach(source, (value, key) => set(result, key, value))

  return result
}

export function getDuplicityErrors(payload: AxiosError): string[] {
  return isPresent(payload.response) && isPresent(payload.response.data.duplicityErrors)
    ? payload.response.data.duplicityErrors
    : []
}

export function getImageByResolution(sources: ImageSource) {
  return window.devicePixelRatio >= 1.25 ? sources.highRes : sources.lowRes
}

export const createblogImageURL = (imagePath: string, base = `${ENDPOINT}/`) => `${base}${imagePath}`

export const toFixed = (value: number | null) => (isPresent(value) ? Number(value.toFixed(2)) : null)



// WEBPACK FOOTER //
// ./src/app/shared/utils/common.ts